import React, { useEffect, useState } from "react";
import { Button, Form, ListGroup } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteProposal,
  downloadProposal,
  getUserProposals,
} from "../../store/actions/proposals/proposals.actions";
import Spinner from "../spinner/Spinner";
import {
  Link,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { useFeatureAccess } from "../../hooks/useFeatureAccess";

const RecentProposal = ({ setModalShow, showFormTab, showEmailPopup }) => {
  let params = useParams();
  let [searchParams] = useSearchParams();
  const { id: editId } = params;
  const proposalList = useSelector((state) => state.proposalList);
  const { user } = useSelector((state) => state.auth);
  const { user: profile } = useSelector((state) => state.userDetails);
  const { loading, proposals } = proposalList;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [checkBox, setCheckBox] = useState(false);
  const { hasFeatureAccess, enforceAccess } =
    useFeatureAccess("Cleanup Proposal");

  useEffect(() => {
    if (user) {
      dispatch(getUserProposals());
    }
  }, [user, profile?.trade, dispatch]);

  const handleSetModal = (e) => {
    e.preventDefault();
    setModalShow(true);
  };
  const handleDownload = (e, id, proposal) => {
    e.preventDefault();
    let propsalNew = (proposal["checkBox"] = checkBox);

    if (!hasFeatureAccess) {
      enforceAccess();
    } else {
      dispatch(downloadProposal(id, `${proposal.project_name}_${Number(proposal.bid_amount)}`));
    }
  };
  const handleDelete = (e, id) => {
    e.preventDefault();
    let response = window.confirm("Are you Sure you want to delete Proposal?");
    if (response) {
      dispatch(deleteProposal(id, editId));
    }
  };

  const handleShowPopup = (proposal) => {
    if (!hasFeatureAccess) {
      enforceAccess();
    } else {
      showEmailPopup(proposal)
    }
  }

  const handleRedirectSetting = () => {
    navigate("/proposal?tabKey=profile");
  };

  const updateQueryParams = (newParams) => {
    const currentUrl = new URL(window.location.href);
    const searchParams = new URLSearchParams(currentUrl.search);

    newParams.forEach((key) => {
      searchParams.delete(key);
    });

    navigate(`${currentUrl.pathname}?${searchParams.toString()}`, { replace: true });
  };

  const getPageNumber = (url) => {
    if (!url) return null;

    const urlObj = new URL(url);
    return urlObj.searchParams.get("page");
  }

  useEffect(() => {
    let proposalId = searchParams.get("download_id");
    let name = searchParams.get("name");
    if (proposalId) {
      if (proposalId) dispatch(downloadProposal(proposalId, name));
      else navigate("/my_proposal?show_tab=recent");
      updateQueryParams(["download_id", "name"]);
    }
  }, [searchParams]);

  useEffect(() => {
    // Load checkbox state from localStorage
    const savedCheckBoxState = localStorage.getItem("downloadSupportDocs");
    if (savedCheckBoxState !== null) {
      setCheckBox(JSON.parse(savedCheckBoxState));
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("downloadSupportDocs", JSON.stringify(checkBox));
  }, [checkBox]);
  const recentProposal = () => {
    return proposals?.results?.map((proposal, index) => {
      return (
        <ListGroup.Item
          key={proposal.id}
          as="li"
          className="d-flex align-items-start  "
        >
          <div className="text-start w-100 ps-2">
            <div className="fw-bold d-flex justify-content-between align-items-center">
              <div>
                {index + 1}. {""}
                <Link
                  className="me-5 d-inline-block text-decoration-none"
                  to={hasFeatureAccess ? `/my_proposal/edit/${proposal.id}` : '/pricing'}
                  onClick={() => showFormTab("home")}
                >
                  {proposal.project_name}_$
                  {Number(proposal.bid_amount)}_Proposal{" "}
                </Link>
              </div>
              <div className="d-flex flex-column">
                <Link
                  className="me-5 d-inline-block text-decoration-none"
                  to={hasFeatureAccess ? `/my_proposal/edit/${proposal.id}` : '/pricing'}
                  onClick={() => showFormTab("home")}
                >
                  Edit
                </Link>
                <Button
                  style={{ color: "#fff" }}
                  className="d-inline-block btn-block btn-danger me-3 my-3"
                  onClick={(e) => handleDelete(e, proposal.id)}
                >
                  Delete
                </Button>

                <Button
                  className="d-inline-block btn-block"
                  onClick={(e) => handleDownload(e, proposal.id, proposal)}
                >
                  Download
                </Button>
                <Button
                  className="d-inline-block btn-block btn-secondary mt-3"
                  onClick={() => handleShowPopup(proposal)}
                >
                  Email Proposal
                </Button>
              </div>
            </div>
            <div className="text-start">
              <span className="fw-bolder">create date:</span>{" "}
              {new Date(proposal.modified).toUTCString().slice(0, 16)}
            </div>
          </div>
        </ListGroup.Item>
      );
    });
  };
  return (
    <>
      {loading && !proposals?.next ? (
        <Spinner />
      ) : (
        <ListGroup as="ul">
          {user ? (
            <>
              {proposals?.results?.length ? (
                <>
                  <ListGroup.Item
                    as="li"
                    className="d-flex align-items-start  "
                  >
                    <div className="text-start w-100 ps-2 d-flex gap-5 align-items-center">
                      <Form.Group
                        controlId="formFile1"
                        className="my-5 align-item-center "
                      >
                        <Form.Check
                          type="checkbox"
                          id="default-checkbox"
                          label="Download supporting docs"
                          onChange={() => setCheckBox(!checkBox)}
                          checked={checkBox}
                        />
                      </Form.Group>
                      <Button
                        variant="secondary"
                        onClick={handleRedirectSetting}
                      >
                        Update{" "}
                      </Button>
                    </div>
                  </ListGroup.Item>

                  {recentProposal()}
                </>
              ) : (
                <h4>Nothing to show here, create a new proposal!</h4>
              )}
            </>
          ) : (
            <div>
              <Button variant="primary" type="submit" onClick={handleSetModal}>
                Login{" "}
              </Button>
              <h4>to see Recent Proposals</h4>
            </div>
          )}
          {loading && proposals?.next ? (
            <Spinner />
          ) : proposals?.next && (
            <ListGroup.Item>
              <Button
                variant="primary"
                onClick={() => dispatch(getUserProposals(getPageNumber(proposals.next)))}
              >
                Load More {(proposals.count - proposals.results.length) > 20 ? 20 : proposals.count - proposals.results.length} proposals
              </Button>
            </ListGroup.Item>
          )}
        </ListGroup>
      )}
    </>
  );
};

export default RecentProposal;
